import {
    ITenantContextProviderConfigurator
} from "sirius-shell-support-library/tenants/configurators/tenant-context-provider-configurator.interface";

export class TenantContextProviderConfigurator implements ITenantContextProviderConfigurator {

    private runtimeEnvironmentsMappings: Record<string, string> = {
        'https://localhost.dell.com': '/cdn/tdp-tenant-context-provider/main.js',
        'https://csm-td-staging.dell.com': '/cdn/tdp-tenant-context-provider/latest/main.js',
        'https://csm-td-int.dell.com': '/cdn/tdp-tenant-context-provider/latest/main.js',
        'https://tdm.dell.com': '/cdn/tdp-tenant-context-provider/latest/main.js',
    };

    public getTenantContextProviderBundleUrl(): string {
        const origin = window.location.origin.toLowerCase();
        return this.runtimeEnvironmentsMappings[origin];
    }
}
